import React, { useEffect, useState } from 'react';
import { Button, Col, Flex, Row, theme,Card } from 'antd';
import ModuleCard from './components/module_card';
import Activity from './components/activity';
import ManageLocalStorage from 'utils/local-storage';
import { useTranslation } from 'react-i18next';

const data = [
    {
        key: 'FOB-R',
        icon: 'fa-solid fa-bag-shopping',
        code: 'fob',
        name: 'Quản lý kinh doanh',
        description: 'Quản lý đơn hàng, báo giá, hóa đơn bán và theo dõi giao hàng',
        status: 'available',
        category: 'Sale',
        // color: '#0052AD',
        path: '/fob',
        statistic: [
            {
                key: 'FOB_STA-REV-R',
                code: 'monthly_revenue',
                name: 'Doanh thu tháng',
                value: '-',
                icon: '',
                unit: 'VNĐ'
            },
            {
                key: 'FOB_STA-REV-R',
                code: 'today_order',
                name: 'Đơn đặt hàng hôm nay',
                value: '-',
                icon: '',
                unit: ''
            },{
                key: 'FOB_STA-REV-R',
                code: 'today_purchase',
                name: 'Đơn mua hàng hôm nay',
                value: '-',
                icon: '',
                unit: ''
            },
        ],
        feature: [
            {
                key: 'FOB_INV-INV-C',
                code: 'order_creation',
                name: 'Tạo đơn hàng',
                path: '/fob/sale_orders/add?step=1'
            },
            {
                key: 'FOB_BOM-BOM_DOC-C',
                code: 'order_breakdown',
                name: 'BOM đơn hàng',
                path: '/fob/bom/list'
            },
            {
                key: 'FOB_PUR-PUR_INV_ORD-C',
                code: 'purchase_order',
                name: 'Đơn đặt mua',
                path: '/fob/purchase_material/fob_purchase_invoice/list'
            }
        ]
    },
    {
        key: 'MES-R',
        icon: 'fa-solid fa-industry',
        code: 'mes',
        name: 'Quản lý sản xuất',
        description: 'Quản lý kế hoạch sản xuất, SAM, may mẫu, BOM, định mức nguyên phụ liệu, sơ đồ chuyền và theo dõi tiến độ',
        status: 'available',
        category: 'Production',
        // color: '#FF4000',
        path: '/mes',
        statistic: [
            {
                key: 'MES_STA-MPRO_ORD-R',
                code: 'production_order_in_progress',
                name: 'Lệnh sản xuất đang chạy',
                value: '36',
                icon: 'fa-solid fa-gears'
            },
            {
                key: 'MES_STA-LIN_EFF-R',
                code: 'chain_efficiency',
                name: 'Hiệu suất chuyền',
                value: '92%',
                icon: 'fa-solid fa-chart-line'
            },
            {
                key: 'MES_STA-SAM_APP-R',
                code: 'sam_approved',
                name: 'SAM đã duyệt',
                value: '125',
                icon: 'fa-solid fa-stopwatch'
            }
        ],
        feature: [
            {
                key: 'MES_PLA-MAS_PLA-R',
                code: 'production_plan',
                name: 'Kế hoạch sản xuất',
                path: '/mes/plan/mes_master_plan/list'
            },
            {
                key: 'MES_SAM-SAM_VER-R',
                code: 'sam_management',
                name: 'Quản lý SAM',
                path: '/mes/categories/mes_style/list'
            },
            {
                key: 'MES_PRE-MPRO_ORD-R',
                code: 'production_order',
                name: 'Lệnh sản xuất',
                path: '/mes/pre/mes_production_order/list'
            }
        ]
    },
    {
        key: 'FIN-R',
        icon: 'fa-solid fa-calculator',
        code: 'fin',
        name: 'Tài chính kế toán',
        description: 'Quản lý thu chi, công nợ, ngân sách, sổ sách kế toán, tài sản tài chính và báo cáo tài chính',
        status: 'available',
        category: 'Administrative',
        // color: '#2D8643',
        path: '/fin',
        statistic: [
            {
                key: 'FIN_REVENUE',
                code: 'monthly_revenue',
                name: 'Doanh thu tháng',
                value: '15.2 tỷ',
                icon: 'fa-solid fa-sack-dollar'
            },
            {
                key: 'FIN_PAYABLE',
                code: 'payable',
                name: 'Công nợ phải trả',
                value: '3.5 tỷ',
                icon: 'fa-solid fa-file-invoice-dollar'
            },
            {
                key: 'FIN_RECEIVABLE',
                code: 'receivable',
                name: 'Công nợ phải thu',
                value: '5.8 tỷ',
                icon: 'fa-solid fa-wallet'
            }
        ],
        feature: [
            {
                key: 'FIN_VOUCHER',
                // code: 'receivable',
                name: 'Phiếu thu chi',
                path: '/finance/vouchers'
            },
            {
                key: 'FIN_LEDGER',
                // code: 'receivable',
                name: 'Sổ kế toán',
                path: '/finance/ledger'
            },
            {
                key: 'FIN_REPORT',
                // code: 'receivable',
                name: 'Báo cáo tài chính',
                path: '/finance/reports'
            }
        ]
    },
    {
        key: 'HRM-R',
        icon: 'fa-solid fa-users',
        code: 'hrm',
        name: 'Hành chính - nhân sự',
        description: 'Quản lý tuyển dụng, hồ sơ nhân sự, hợp đồng lao động, bảo hiểm, thuế, chấm công và tiền lương',
        status: 'available',
        category: 'Administrative',
        // color: '#B85814',
        path: '/hrm',
        statistic: [
            {
                key: 'EMPLOYEE_TOTAL',
                code: 'current_headcount',
                name: 'Nhân sự hiện tại',
                value: '3,250',
                icon: 'fa-solid fa-user-group'
            },
            {
                key: 'RECRUITING',
                code: 'job_vacancies',
                name: 'Vị trí tuyển dụng',
                value: '32',
                icon: 'fa-solid fa-user-plus'
            },
            {
                key: 'PAYROLL_MONTH',
                code: 'monthly_payroll',
                name: 'Quỹ lương tháng',
                value: '18 tỷ',
                icon: 'fa-solid fa-money-check-dollar'
            }
        ],
        feature: [
            {
                key: 'HRM_CON-EMP_CON-R',
                code: 'employment_contract',
                name: 'Hợp đồng nhân sự',
                path: '/hrm/contract/hrm_employment_contract/list'
            },
            {
                key: 'HRM_ATT-TIM_DET-R',
                code: 'time_attendance',
                name: 'Chấm công',
                path: '/hrm/attendance/hrm_timesheet_detail/list'
            },
            {
                key: 'HRM_SAL-PAY_SUM-R',
                code: 'payroll',
                name: 'Tiền lương',
                path: '/hrm/salary/hrm_payroll_summary/list'
            }
        ]
    },
    {
        key: 'RE-R',
        icon: 'fa-solid fa-warehouse',
        code: 're',
        name: 'Quản lý kho',
        description: 'Quản lý nhập xuất tồn, vị trí kho, kiểm kê, truy xuất nguyên phụ liệu và thành phẩm',
        status: 'available',
        category: 'Logistic',
        // color: '#CF0505',
        path: '/re',
        statistic: [
            {
                key: 'WH_IMPORT',
                code: 'today_stock_received',
                name: 'Phiếu nhập hôm nay',
                value: '56',
                icon: 'fa-solid fa-arrow-down'
            },
            {
                key: 'WH_EXPORT',
                code: 'today_stock_issued',
                name: 'Phiếu xuất hôm nay',
                value: '48',
                icon: 'fa-solid fa-arrow-up'
            },
            {
                key: 'WH_INVENTORY',
                code: 'inventory_value',
                name: 'Giá trị tồn kho',
                value: '25 tỷ',
                icon: 'fa-solid fa-boxes-stacked'
            }
        ],
        feature: [
            {
                key: 'RE_STO-INW_ORD-R',
                code: 'stock_receipt',
                name: 'Nhập kho',
                path: '/re/storage/re_inward_order/list'
            },
            {
                key: 'RE_STO-OUT_ORD-R',
                code: 'stock_issue',
                name: 'Xuất kho',
                path: '/re/storage/re_outward_order/list'
            },
            {
                key: 'RE_CAT-STO_ITE-R',
                code: 'inventory',
                name: 'Tồn kho',
                path: '/re/categories/re_storage_item/list'
            }
        ]
    },
    {
        key: 'ASM-R',
        icon: 'fa-solid fa-building-circle-check',
        code: 'asm',
        name: 'Quản lý tài sản',
        description: 'Quản lý tài sản cố định, công cụ dụng cụ, bảo trì, bảo dưỡng và khấu hao',
        status: 'available',
        category: 'Administrative',
        // color: '#0052AD',
        path: '/asm',
        statistic: [
            {
                key: 'ASSET_TOTAL',
                code: 'total_assets',
                name: 'Tổng tài sản',
                value: '1,250',
                icon: 'fa-solid fa-building'
            },
            {
                key: 'ASSET_MAINTAIN',
                code: 'monthly_maintenance',
                name: 'Bảo trì tháng',
                value: '35',
                icon: 'fa-solid fa-screwdriver-wrench'
            },
            {
                key: 'ASSET_DEPRECIATION',
                code: 'monthly_depreciation',
                name: 'Khấu hao tháng',
                value: '850 triệu',
                icon: 'fa-solid fa-chart-column'
            }
        ],
        feature: [
            {
                key: 'ASM_CAT-ASS_DET-R',
                code: 'asset_register',
                name: 'Danh mục tài sản',
                path: '/asm/asset/asm_asset_detail/list'
            },
            {
                key: 'ASM_AS-MAI_REP-R',
                code: 'maintenance',
                name: 'Bảo trì - bảo dưỡng',
                path: '/asm/asset/asm_maintenance_report/list'
            },
            {
                key: 'ASM_AS-ASS_OPE-R',
                code: 'operations',
                name: 'Điều hành',
                path: '/asm/asset/asm_asset_operation/list'
            }
        ]
    },
    {
        key: 'TMS-R',
        icon: 'fa-solid fa-truck-fast',
        code: 'tms',
        name: 'Quản lý vận tải',
        description: 'Quản lý phương tiện, điều xe, giao nhận hàng hóa, định vị và chi phí vận chuyển',
        status: 'available',
        category: 'Logistic',
        // color: '#CF0505',
        path: '/tms',
        statistic: [
            {
                key: 'TRIP_TODAY',
                code: 'today_trips',
                name: 'Chuyến xe hôm nay',
                value: '42',
                icon: 'fa-solid fa-route'
            },
            {
                key: 'VEHICLE_ACTIVE',
                code: 'active_vehicles',
                name: 'Xe đang hoạt động',
                value: '28',
                icon: 'fa-solid fa-truck'
            },
            {
                key: 'TRANSPORT_COST',
                code: 'monthly_expenses',
                name: 'Chi phí tháng',
                value: '650 triệu',
                icon: 'fa-solid fa-gas-pump'
            }
        ],
        feature: [
            {
                key: 'TMS_OPR-TRA_PLA-R',
                code: 'transport_plan',
                name: 'Kế hoạch vận tải',
                path: '/tms/operations/tms_transport_plan/list'
            },
            {
                key: 'TMS_OPR-COS-R',
                code: 'costing_sheet',
                name: 'Bảng tính chi phí',
                path: '/tms/operations/tms_costing/list'
            },
            {
                key: 'TMS_OPR-CAR-R',
                code: 'transport_provider',
                name: 'Đơn vị cung ứng vận tải',
                path: '/tms/operations/tms_carrier/list'
            }
        ]
    },
    {
        key: 'QAS-R',
        icon: 'fa-solid fa-user-shield',
        code: 'qas',
        name: 'Quản lý chất lượng',
        description: 'Quản lý kiểm tra chất lượng nguyên phụ liệu, bán thành phẩm, thành phẩm và xử lý lỗi',
        status: 'available',
        category: 'Production',
        // color: '#2D8643',
        path: '/qas',
        statistic: [
            {
                key: 'QC_RESULT',
                code: 'quality-compliant_batches',
                name: 'Lô đạt chất lượng',
                value: '98%',
                icon: 'fa-solid fa-circle-check'
            },
            {
                key: 'QC_DEFECT',
                code: 'detected_defects',
                name: 'Lỗi phát hiện',
                value: '126',
                icon: 'fa-solid fa-bug'
            },
            {
                key: 'QC_AUDIT',
                code: 'assessment_rounds',
                name: 'Đợt đánh giá',
                value: '12',
                icon: 'fa-solid fa-clipboard-check'
            }
        ],
        feature: [
            {
                key: 'QAS_INS-INS_PLA-R',
                code: 'inspection_plan',
                name: 'Kiểm tra chất lượng',
                path: '/qas/categories/qas_inspection_plan/list'
            },
            {
                key: 'QAS_INS-DOC-R',
                code: 'inspection_document',
                name: 'Tài liệu tiểu chuẩn',
                path: '/qas/categories/qas_documentation/list'
            },
            {
                key: 'QAS_AQL-R',
                code: 'AQL',
                name: 'AQL',
                path: '/qas/categories/qas_aql_sampling/table'
            },
        ]
    },
    {
        key: 'COM-R',
        icon: 'fa-solid fa-diagram-project',
        code: 'com',
        name: 'Quản lý quy trình, quy định',
        description: 'Quản lý quy trình nghiệp vụ, biểu mẫu, quy định nội bộ, ISO và luồng phê duyệt',
        status: 'available',
        category: 'Administrative',
        // color: '#007AE5',
        path: '/com',
        statistic: [
            {
                key: 'PROCESS_TOTAL',
                code: 'active_processes',
                name: 'Quy trình đang áp dụng',
                value: '245',
                icon: 'fa-solid fa-sitemap'
            },
            {
                key: 'DOC_TOTAL',
                code: 'management_documents',
                name: 'Tài liệu quản lý',
                value: '1260',
                icon: 'fa-solid fa-file-lines'
            },
            {
                key: 'WORKFLOW_ACTIVE',
                code: 'approval_workflow',
                name: 'Luồng phê duyệt',
                value: '58',
                icon: 'fa-solid fa-code-branch'
            }
        ],
        feature: [
            {
                key: 'COM_CAT-CWOR-R',
                code: 'process',
                name: 'Quy trình',
                path: '/com/categories/com_workflow/list'
            },
            {
                key: 'COM_CAT-CREP-R',
                code: 'form',
                name: 'Biểu mẫu',
                path: '/com/categories/com_report/list'
            },
        ]
    },
    {
        key: 'EXECUTIVE-R',
        icon: 'fa-solid fa-chart-pie',
        code: 'man',
        name: 'Quản trị điều hành',
        description: 'Cung cấp dashboard điều hành, KPI, OKR, phân tích dữ liệu và hỗ trợ ra quyết định chiến lược',
        status: 'available',
        category: 'Executive',
        // color: '#FFAB4C',
        path: '/man',
        statistic: [
            {
                key: 'KPI_COMPLETE',
                code: 'kpis_achieved',
                name: 'KPI hoàn thành',
                value: '89%',
                icon: 'fa-solid fa-bullseye'
            },
            {
                key: 'PROFIT_MONTH',
                code: 'monthly_profit',
                name: 'Lợi nhuận tháng',
                value: '4.2 tỷ',
                icon: 'fa-solid fa-coins'
            },
            {
                key: 'ALERT_TOTAL',
                code: 'operational_alerts',
                name: 'Cảnh báo điều hành',
                value: '12',
                icon: 'fa-solid fa-triangle-exclamation'
            }
        ],
        feature: [
            {
                key: 'EXEC_DASHBOARD',
                code: 'dashboard',
                name: 'Dashboard điều hành',
                path: '/executive/dashboard'
            },
            {
                key: 'EXEC_KPI',
                code: 'exec_kpi',
                name: 'KPI & OKR',
                path: '/executive/kpi'
            },
            {
                key: 'EXEC_BI',
                code: 'bi_analytic',
                name: 'BI Analytics',
                path: '/executive/analytics'
            }
        ]
    }
];

const ModuleList = (props) => {
    const { token } = theme.useToken(); 
    const [modules, setModules] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [category, setCategory] = useState([]);
    const [filter, setFilter] = useState('all');
    const { t } = useTranslation(['home']);
    const {
        fullBleed = true,
        fullBleedPadding = 20,
        isbg = true,
    } = props;


    useEffect(() => {
        setModules(data);
        let cat = [
            {
                key: 'all',
                label: 'All',
                total: data.length
            }
        ];
        for(let i=0; i<data.length; i++) {
            let idx = cat.findIndex(x => x.key === data[i].category);
            if (idx >=0) {
                cat[idx].total += 1;
            }
            else {
                cat.push({
                    key: data[i].category,
                    label: data[i].category,
                    total: 1
                })
            }
        }
        setCategory(cat);
    }, [])

    useEffect(() => {
        if(filter === 'all') setFilterList(modules);
        else setFilterList(modules.filter(x => x.category === filter));
    }, [modules, filter])

    const handleFilter = (e) => {
        setFilter(e.key);
    }

    return (
        <div>
            <Card className="ant-main-card" style={{ borderColor: `${token.colorPrimary}` }}>
                <h5 style={{ textTransform: 'uppercase' }}>{t(`control_center`, 'Trung tâm điều hành')}</h5>
                <div
                    className={`py-2 list_index_action`}
                    style={{
                        ...(isbg && {
                            backgroundColor: token.controlItemBgActiveDisabled,
                        }),
                        width: fullBleed ? `calc(100% + ${fullBleedPadding * 2}px)` : '100%',
                        marginLeft: fullBleed ? -fullBleedPadding : undefined,
                        marginRight: fullBleed ? -fullBleedPadding : undefined,
                        paddingLeft: fullBleed ? fullBleedPadding : undefined,
                        paddingRight: fullBleed ? fullBleedPadding : undefined,
                        boxSizing: 'border-box',
                        marginBottom: 10,
                    }}
                >
                    <Flex justify="flex-start" align="center" style={{ gap: 4 }} wrap="wrap">
                        {category.map((e) => (
                            <Button
                                key={e.key}
                                size="small"
                                type={e.key === filter ? 'primary' : 'default'}
                                className="pl-3 pr-3"
                                onClick={() => handleFilter(e)}
                            >
                                <span className="transition-colors">{t(`apps.categories.${e.label}`, e.label)}</span>
                                <span className="font-size-sm text-foreground ml-1">({e.total})</span>
                            </Button>
                        ))}
                    </Flex>
                </div>

                <Row gutter={[16, 16]}>
                    <Col xs={24} xl={16}>
                        <Row gutter={[16, 16]}>
                            {filterList.map((e) => (
                                <Col key={e.key} xs={24} sm={12} md={8}>
                                    <ModuleCard
                                        module={e}
                                        disabled={!ManageLocalStorage.check_role(e.key)}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col xs={24} xl={8}>
                        <Activity />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export default ModuleList;

